import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

interface PacsImageIdentifier {
  examId: string;
  linkLiveDurationInHours?: number;
  organizationId: string;
  patientId: string;
}

interface PacsIntegrationResult {
  url: string;
}

interface PacsIntegrationState {
  enabled: boolean;
  type: string;
}

export default class PacsLinkGeneratorService {
  public getPacsLink(imageId: PacsImageIdentifier): Promise<PacsIntegrationResult> {
    const { patientId, examId, organizationId, linkLiveDurationInHours } = imageId;
    return HttpService.get(APPLICATION_ENDPOINTS.PACS_LINK_GENERATION, {
      examId,
      linkLiveDurationInHours,
      organizationId,
      patientId,
    }, {}).then(r => r.body as PacsIntegrationResult);
  }

  public getPacsState(): Promise<PacsIntegrationState> {
    return HttpService.get(APPLICATION_ENDPOINTS.PACS_STATE, {}, {}).then(r => r.body as PacsIntegrationState);
  }

  public async openPacsInChrome(imageId: PacsImageIdentifier, windowReference: Window | null): Promise<void> {
    const pacsLinkResult: PacsIntegrationResult = await this.getPacsLink(imageId);
    if (!pacsLinkResult || !pacsLinkResult.url) {
      throw 'Error launching integration'
    }

    if (windowReference) {
      windowReference.location = pacsLinkResult.url;
    }
  }
}